import React from 'react';
import classNames from 'classnames';
import { InputSelectGroup } from '@justgiving/dna-form';
import { Select } from '../dna';
import { inputDNAClassNames, FieldProps } from '../../helpers/forms';
import { ValidationResult } from '../../helpers/validation';
import {
  currencyMap,
  getCurrencyMessage,
  SupportedCurrency,
} from 'src/helpers/currencyMap';

interface Props {
  targetAmount: FieldProps;
  targetCurrency: FieldProps;
  styles: Styles;
  supportedCurrencies: SupportedCurrency[];
}

class AmountWithCurrencyField extends React.Component<Props, {}> {
  formField: any;
  inputSelectGroup: any;

  componentDidMount() {
    this.inputSelectGroup = new InputSelectGroup({
      el: this.formField,
      selectWidth: 100,
      selectOptionsWidth: this.formField.offsetWidth,
      bindSelectValueToPrefix: true,
      selectValueAsSelected: true,
      bindingTransform: (value: Currency) => currencyMap[value],
    });
  }

  componentWillUnmount() {
    delete this.inputSelectGroup;
  }

  getCurrencyOptions() {
    const currencyOptions: { [key: string]: string } = {};

    Object.values(this.props.supportedCurrencies).forEach(x => {
      currencyOptions[x.currency.code] = x.currency.name;
    });

    return currencyOptions;
  }

  render() {
    const { targetAmount, targetCurrency, styles } = this.props;

    return (
      <div
        className="dna-input-select-group"
        ref={c => {
          this.formField = c;
        }}
      >
        <div className="dna-form-field">
          <label
            className={classNames('dna-label', styles.label)}
            htmlFor="donation-amount"
          >
            Weʼre raising
          </label>
          <div className={styles['target-currency']}>
            <div className={styles['target-wrapper']}>
              <input
                {...targetAmount.input}
                id="target"
                className={inputDNAClassNames(
                  {
                    touched: targetAmount.meta.touched ? true : false,
                    error: targetAmount.meta.error,
                  },
                  'dna-input',
                  'dna-input-text',
                  'js-dna-input-prefix',
                  styles.target
                )}
                data-dna-input-prefix="£"
                type="number"
              />
            </div>
            <Select
              {...targetCurrency.input}
              id="currency"
              className="js-dna-select"
              fieldClass={styles.currency}
              disableMobileNative
              isLabelHidden
              value={targetCurrency.input.value}
              handleChange={value => targetCurrency.input.onChange(value)}
              options={this.getCurrencyOptions()}
            />
          </div>
          <ValidationResult
            touched={targetAmount.meta.touched}
            error={targetAmount.meta.error}
          />
          <p className={styles.note}>You can edit your target later.</p>
          <p className={styles.note}>
            {getCurrencyMessage(targetCurrency.input.value)}
          </p>
        </div>
      </div>
    );
  }
}

export default AmountWithCurrencyField;



// WEBPACK FOOTER //
// ./src/components/CreateForm/AmountWithCurrencyField.tsx